import styled from "@emotion/styled/macro";
import { Banner, BannerTypes } from "@sunrun/experience-ui-components";
import appStoreIcon from "components/assets/images/app-store.png";
import googlePlayIcon from "components/assets/images/google-play.png";
import { mobileMaxWidth } from "components/atoms/GlobalStyles";

const CALLPILOT_APP_STORE_URL =
  "https://apps.apple.com/us/app/callpilot/id1555414269";
const CALLPILOT_GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.safehomedirect.callpilot&pcampaignid=web_share";
const CALLPILOT_TITLE = "You can also use the Callpilot app";

const STORE_BADGE_WIDTH = 151;
const STORE_BADGE_HEIGHT = 45;

const CallpilotAppBanner = () => (
  <StyledBanner
    bannerType={BannerTypes.InfoLight}
    show
    showClose={false}
    showIcon
    title={CALLPILOT_TITLE}
    bannerTestId="callpilot-download-prompt"
    customButtons={
      <StoreBadges>
        <a
          href={CALLPILOT_APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="callpilot-app-store-link"
        >
          <img
            src={appStoreIcon}
            alt="Download on the App Store"
            width={STORE_BADGE_WIDTH}
            height={STORE_BADGE_HEIGHT}
          />
        </a>
        <a
          href={CALLPILOT_GOOGLE_PLAY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="callpilot-google-play-link"
        >
          <img
            src={googlePlayIcon}
            alt="Get it on Google Play"
            width={STORE_BADGE_WIDTH}
            height={STORE_BADGE_HEIGHT}
          />
        </a>
      </StoreBadges>
    }
  />
);

const StyledBanner = styled(Banner)`
  width: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;

  .sr-banner-body {
    min-width: 250px;
  }

  .sr-banner-action-buttons {
    max-height: none;
    align-items: center;
    gap: 8px;
  }

  @media (max-width: ${mobileMaxWidth}px) {
    flex-wrap: wrap;
    align-items: flex-start;

    .sr-banner-body {
      flex-basis: calc(100% - 46px);
    }

    .sr-banner-action-buttons {
      flex-basis: 100%;
      width: 100%;
      margin: 0;
      padding-left: 46px;
    }
  }
`;

const StoreBadges = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    display: block;
    width: ${STORE_BADGE_WIDTH}px;
    height: ${STORE_BADGE_HEIGHT}px;
  }

  @media (max-width: ${mobileMaxWidth}px) {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
`;

export {
  CallpilotAppBanner,
  CALLPILOT_APP_STORE_URL,
  CALLPILOT_GOOGLE_PLAY_URL,
  CALLPILOT_TITLE,
};
